/**
 * Author:  LiShibin.
 * Date:    2016/12/27.
 * File：   服务端接口错误信息中英文映射表
 */

let errorMap = [{
  en: 'INVALID_DATA CONTENT:orgId invalid.',
  cn: '组织机构Id无效'
}, {
  en: 'INVALID_DATA CONTENT:proclamationId invalid.',
  cn: '公告Id无效'
}, {
  en: 'INVALID_DATA CONTENT:deadline invalid.',
  cn: '已超过投票截止日'
}, {
  en: 'INVALID_DATA CONTENT:problemType and optionMaxAmount conflict.',
  cn: '投票选项超过最大选项数'
}, {
  en: 'INVALID_DATA CONTENT:voteId invalid.',
  cn: '投票Id无效'
}, {
  en: 'INVALID_DATA CONTENT:proclamationId invalid.',
  cn: '公告Id无效'
}, {
  en: 'INVALID_DATA CONTENT:user invalid.',
  cn: '该用户对于当前投票无效'
}, {
  en: 'INVALID_DATA CONTENT:voteTime exceed deadline',
  cn: '已超过投票截止时间'
}, {
  en: 'INVALID_DATA CONTENT:problemId invalid.',
  cn: '投票的问题Id无效'
}, {
  en: 'INVALID_DATA CONTENT:optionId invalid.',
  cn: '投票的选项Id无效'
}, {
  en: 'INVALID_DATA CONTENT:options is too much',
  cn: '投票选项超过最大选项数'
}, {
  en: 'INVALID_DATA CONTENT:user is already vote',
  cn: '您已投票过了'
}, {
  en: 'INVALID_DATA CONTENT:The process is suspended or null',
  cn: '该审批被暂停或为空。'
}, {
  en: 'INVALID_DATA CONTENT:this attndStatus can not allow to appeal.',
  cn: '不允许申述'
}, {
  en: 'INVALID_DATA CONTENT:data not exist.',
  cn: '找不到当前申述，可能已被撤销，请同发起人进行确认。'
}, {
  en: 'INVALID_DATA CONTENT:time out.',
  cn: '已超过申述时效，不能发起申述。'
}, {
  en: 'INVALID_DATA CONTENT:not allow appeal.',
  cn: '不允许申述。'
}, {
  en: 'INVALID_DATA CONTENT:no leader.',
  cn: '没有找到你的上级领导，请联系管理员。'
}, {
  en: 'INVALID_DATA CONTENT:no permission operation.',
  cn: '没有权限操作'
}, {
  en: 'DATA_IS_ALREADY_EXIST CONTENT:theme exist.',
  cn: '活动主题名称已存在,请修改活动主题名称'
}, {
  en: 'INVALID_DATA CONTENT:have to deal with.',
  cn: '没权限进行操作，本条申述已被其他人处理。'
}, {
  en: 'INVALID_DATA CONTENT:department_id is not null',
  cn: '当前用户缺少部门信息，请联系管理员进行分配！'
}]

/**
 * 获取中文提示
 * @param en 英文字符串
 * @return {String}
 */
function getErrorCn (en) {
  for (let i = 0; i < errorMap.length; i++) {
    if (errorMap[i].en === en) {
      return errorMap[i].cn
    }
  }
  return ''
}

export {errorMap, getErrorCn}



// WEBPACK FOOTER //
// ./src/post/errorMap.js